module.exports = __webpack_public_path__ + "static/media/CV.547fb316.png";